import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as variables_default from '../tokens/js/variables.default.js';
import * as variables_globetrotter from '../tokens/js/variables.globetrotter.js';
import { siteThemes } from './theming.js';

var toKebabCase = function toKebabCase(str) {
  return str.split('_').map(function (word) {
    return word.toLowerCase();
  }).join('-');
};
var categorizeByDevice = function categorizeByDevice(variables) {
  var variablesByDevice = {
    mobile: {},
    tablet: {},
    desktop: {}
  };
  Object.entries(variables).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (key.match(/APP_|_APP/)) {
      return;
    }
    if (key.includes('_DESKTOP')) {
      variablesByDevice.desktop[key.replace('_DESKTOP', '')] = value;
    } else if (key.includes('_TABLET')) {
      variablesByDevice.tablet[key.replace('_TABLET', '')] = value;
    } else {
      variablesByDevice.mobile[key.replace('_MOBILE', '')] = value;
    }
  });
  return variablesByDevice;
};
var tokensToCss = function tokensToCss(object) {
  var tokensByDevice = categorizeByDevice(object);
  var cssTokens = {};
  Object.keys(tokensByDevice).forEach(function (key) {
    cssTokens[key] = Object.entries(tokensByDevice[key]).reduce(function (css, _ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        tokenKey = _ref4[0],
        value = _ref4[1];
      return "".concat(css, "--").concat(toKebabCase(tokenKey), ": ").concat(value, ";\n");
    }, "");
  });
  return cssTokens;
};
var getCssVariables = function getCssVariables(theme) {
  if (theme === siteThemes.GLOBETROTTER) {
    return tokensToCss(variables_globetrotter);
  }
  return tokensToCss(variables_default);
};
var getCssVariables$1 = getCssVariables;

export { getCssVariables$1 as default };
//# sourceMappingURL=tokensToCss.js.map
